export default "__VITE_ASSET__CiqEIVoB__"